import { useAtomValue } from 'jotai';

import { format } from '@/Resources.resx';
import { HorizontalContainer, Panel, VerticalContainer } from '@/components';
import { InfoIcon } from '@/components/Icons';
import { cn } from '@/lib/cn';

import { R } from '@/caregiverSpace/resources/Texts.resx';

import {
    adolescentMinimumAgeAtom,
    adultMinimumAgeAtom,
} from '@/caregiverSpace/shared/model';

import { isAdolescentPatient } from '../lib/isAdolescentPatient';

type AdolescentPatientWarningProps = {
    dateOfBirth?: string | null;
    className?: string;
};

export const AdolescentPatientWarning = ({
    dateOfBirth,
    className,
}: AdolescentPatientWarningProps) => {
    const adolescentMinimumAge = useAtomValue(adolescentMinimumAgeAtom);
    const adultMinimumAge = useAtomValue(adultMinimumAgeAtom);

    if (
        adolescentMinimumAge === undefined ||
        adultMinimumAge === undefined ||
        !isAdolescentPatient(dateOfBirth, adolescentMinimumAge, adultMinimumAge)
    )
        return null;

    return (
        <Panel type="warning" className={cn('w-full', className)}>
            <VerticalContainer spacing="sm">
                <HorizontalContainer spacing="xs" className="items-center">
                    <InfoIcon variant="warning" className="shrink-0" />
                    <span className="flex-1 font-bold text-(--color-text-heading)">
                        {format(
                            R.AdolescentPatientWarningTitle,
                            adolescentMinimumAge.toString(),
                            (adultMinimumAge - 1).toString(),
                        )}
                    </span>
                </HorizontalContainer>
                <p className="text-(--color-text-primary)">
                    {R.AdolescentPatientWarningDescription}
                </p>
            </VerticalContainer>
        </Panel>
    );
};
